import { TransType } from "system/translations/types";

export const statusOptions = (_t: TransType) => [
  { label: _t("enabled"), value: "enabled" },
  { label: _t("disabled"), value: "disabled" },
];
